import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=32de5967&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=32de5967&prod&scoped=true&lang=css"
import style1 from "./Button.vue?vue&type=style&index=1&id=32de5967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de5967",
  null
  
)

export default component.exports